import { render, staticRenderFns } from "./job-employment-position-resource-item-2-job-position-statistics.vue?vue&type=template&id=42924625&"
import script from "./job-employment-position-resource-item-2-job-position-statistics.vue?vue&type=script&lang=ts&"
export * from "./job-employment-position-resource-item-2-job-position-statistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports